import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { ShellComponent } from './layout/shell/shell.component';
import {TsExportComponent} from './pages/ts-export/ts-export.component';
import {RouteGuardService} from './services/route-guard.service';
import {ExportsComponent} from './pages/exports/exports.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'home',
    component: ShellComponent,
    canActivate: [RouteGuardService],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'ts_export', component: TsExportComponent },
      { path: 'exports', component: ExportsComponent }
    ],
  },
];
